// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_RevokeOverrideInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /ai/credits/pricing/overrides/{id}/revoke
 *
 * No body required — id is a URL path parameter (see ai/pricing.php
 * revoke_override()). Exists so the frontend composable has a real
 * registered InputContract to point `inputContract` at, matching the
 * PlanoMetas_AtivarInput / PlanoMetas_ExcluirInput precedent for other
 * path-only-id write endpoints.
 */
import { registerContract } from './validate'

export interface AiCredits_RevokeOverrideInput {}

registerContract('AiCredits_RevokeOverrideInput', {})
